import { IHero } from "@src/components/Hero";
import { motion } from "framer-motion";
import Image from "next/image";
import React from "react";
import flowerBackground from "../../../../public/images/bw-flower.jpeg";

const Hero: React.FC<IHero> = ({ slugData, loading, openInvitationModal }) => {
  return (
    <div className="w-full h-[100vh] relative overflow-hidden">
      {/* Background Image */}
      <motion.div
        initial={{ scale: 1 }}
        animate={{
          scale: 1,
          transition: {
            delay: 0.3,
            duration: 0.8,
            ease: [0.79, 0.14, 0.15, 0.86],
          },
        }}
        className={
          "relative top-0 bottom-0 right-0 left-0 w-full h-full bg-[#F5E7E9]"
        }
        style={{ filter: "contrast(60%) brightness(120%)" }}
      >
        <Image
          loading="eager"
          layout="fill"
          src={flowerBackground}
          alt="gallery-image"
          className="object-cover object-right md:object-cover md:object-center"
          priority
        />
        <div className="absolute inset-0 bg-[#ebcacf]/25" />
      </motion.div>

      {/* Main Content */}
      <div className="w-full h-full absolute left-0 top-0 z-[4]">
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{
            opacity: 1,
            y: 0,
            transition: {
              duration: 0.7,
              ease: [0.79, 0.14, 0.15, 0.86],
            },
          }}
          className={
            "w-full h-full flex flex-col justify-center items-center border border-[#8F243875]"
          }
        >
          <div
            className="border p-2 md:p-3"
            style={{ borderColor: "rgba(71, 11, 20, 0.32)" }}
          >
            <div
              className="min-w-[290px] md:min-w-[540px] px-5 py-6 md:px-12 md:py-8 text-center border border-[#8F243875]"
              style={{
                backgroundColor: "rgba(235, 202, 207, 0.68)",
              }}
            >
              <h1 className="font-bauerBodoni text-[2rem] md:text-[4rem] leading-[1] tracking-wide text-[#8F2438] uppercase">
                {slugData?.eventBySlug?.name ?? ""}
              </h1>
              <p className="font-bauerBodoni text-[1.1rem] md:text-[1.5rem] mt-3 text-[#8F2438]">
                {loading
                  ? "..."
                  : !!slugData?.eventBySlug && !!slugData?.eventBySlug?.hash_tag
                  ? slugData?.eventBySlug?.hash_tag
                  : ""}
              </p>
            </div>
          </div>

          {openInvitationModal && (
            <motion.button
              onClick={openInvitationModal}
              className="mt-6 w-[50px] h-[50px] rounded-full border border-[#8F2438] bg-[#8F2438] flex items-center justify-center"
              whileHover={{ scale: 1.06 }}
              whileTap={{ scale: 0.95 }}
              aria-label="Go to welcome"
            >
              <svg
                width="24"
                height="20"
                viewBox="0 0 56 87"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g>
                  <line
                    transform="rotate(101.38104248046875 27.75 63.25)"
                    y2="83.75"
                    x2="53.75"
                    y1="42.75"
                    x1="1.75"
                    strokeWidth="5"
                    stroke="#fff"
                    fill="none"
                  />
                  <line
                    y2="41.75"
                    x2="52.75"
                    y1="0.75"
                    x1="0.75"
                    strokeWidth="5"
                    stroke="#fff"
                    fill="none"
                  />
                </g>
              </svg>
            </motion.button>
          )}
        </motion.div>
      </div>
    </div>
  );
};

export default Hero;
